import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        ApiServiceProxies.AbpLanguageTextsServiceProxy,
        ApiServiceProxies.AbpLanguagesServiceProxy,
        ApiServiceProxies.SysMasterListServiceProxy,
        ApiServiceProxies.SysAppParamServiceServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.SysWorkflowServiceProxy,
        ApiServiceProxies.LocationServiceProxy,       
        ApiServiceProxies.MasterDataServiceProxy,       
        ApiServiceProxies.HomeServiceProxy,        
        ApiServiceProxies.HolidayServiceProxy,
        ApiServiceProxies.BonusServiceProxy,
        ApiServiceProxies.AttendanceServiceProxy,
        ApiServiceProxies.EmployeeServiceProxy,
        ApiServiceProxies.SalaryBasicServiceProxy,
        ApiServiceProxies.InsuranceServiceProxy,
        ApiServiceProxies.WorkingProcessServiceProxy,
        ApiServiceProxies.FamilyExemptionServiceProxy,
        ApiServiceProxies.SalaryServiceProxy,
        ApiServiceProxies.RemainingLeaveServiceProxy,
        ApiServiceProxies.ListNotificationServiceProxy,
        ApiServiceProxies.WorkingShiftServiceProxy,
        ApiServiceProxies.AnnualLeaveServiceProxy,
        ApiServiceProxies.RegisterOvertimeServiceProxy,
        ApiServiceProxies.AdvanceSalaryServiceProxy,
        ApiServiceProxies.ContractServiceProxy,
        ApiServiceProxies.ExpenditureIncomeServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
